import { type TileItem } from '../components/Tile/types.ts';

export const getItemsKey = (items: TileItem[]) =>
  items
    .map(item => item.id)
    .sort()
    .join(',');
